import { safeAjax } from "./webapi";
import Shepherd from "Shepherd.js";
let webPageId = null;
let multistepFormId = null;
let formStepId = null;
let currentTour = null;
let currentSteps = [];
let currentStep = null;
let selectElementTarget;
function setDateTimeInput(element, datetimeString) {
    if (!element) {
        return;
    }
    if (!datetimeString) {
        element.value = "";
        return;
    }
    const date = new Date(datetimeString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    element.value = `${year}-${month}-${day}T${hours}:${minutes}`;
}
function getUpdatedProperties(currentObject, newObject) {
    const result = {};
    for (const key in newObject) {
        if (Object.prototype.hasOwnProperty.call(currentObject, key) &&
            Object.prototype.hasOwnProperty.call(newObject, key) &&
            currentObject[key] !== newObject[key]) {
            result[key] = newObject[key];
        }
    }
    return result;
}
function updateMask(target) {
    let highlightElement = Array.from(document.getElementsByClassName("highlight-wrap")).at(0);
    if (!highlightElement) {
        highlightElement = document.createElement("div");
        highlightElement.className = "highlight-wrap";
        highlightElement.style.position = "absolute";
        highlightElement.style.backgroundColor = "#205081";
        highlightElement.style.opacity = "0.5";
        highlightElement.style.cursor = "default";
        highlightElement.style.pointerEvents = "none";
        document.body.appendChild(highlightElement);
    }
    const rect = target.getBoundingClientRect();
    highlightElement.style.left = rect.left + window.scrollX + "px";
    highlightElement.style.top = rect.top + window.scrollY + "px";
    highlightElement.style.width = rect.width + "px";
    highlightElement.style.height = rect.height + "px";
}
function generateCssSelector(element) {
    if (!element) {
        return "";
    }
    const parts = [];
    let currentElement = element;
    while (currentElement && currentElement.nodeType === Node.ELEMENT_NODE) {
        let classList = "";
        let currentSelectorPart = currentElement.tagName.toLowerCase();
        if (currentElement.id) {
            currentSelectorPart += `#${currentElement.id}`;
            parts.unshift(currentSelectorPart);
            break;
        }
        if (currentElement.classList.length) {
            classList = `.${Array.from(currentElement.classList).join(".")}`;
            currentSelectorPart += classList;
        }
        let index = 1;
        let sibling = currentElement.previousElementSibling;
        while (sibling) {
            if (sibling.tagName === currentElement.tagName) {
                let siblingClassList = "";
                if (sibling.classList.length) {
                    siblingClassList = `.${Array.from(sibling.classList).join(".")}`;
                }
                if (classList === siblingClassList) {
                    index++;
                }
            }
            sibling = sibling.previousElementSibling;
        }
        if (index > 1) {
            currentSelectorPart += `:nth-child(${index})`;
        }
        parts.unshift(currentSelectorPart);
        currentElement = currentElement.parentElement;
    }
    return parts.join(" > ");
}
function setSelectElementTarget(target) {
    selectElementTarget = target;
}
function selectElement(event) {
    if (event.target instanceof HTMLElement && selectElementTarget) {
        updateMask(event.target);
    }
}
function removeSelectElementHandlers(event) {
    event.preventDefault();
    event.stopPropagation();
    if (event.target instanceof HTMLElement && selectElementTarget) {
        selectElementTarget.val(selectElementTarget.data("selection-include-quotes")
            ? `"${generateCssSelector(event.target)}"`
            : generateCssSelector(event.target));
    }
    $(document).off("mouseover", selectElement);
    $(".highlight-wrap").remove();
    selectElementTarget = null;
    $("#manage-tours-sidebar").show();
}
function populateTourSelect() {
    let apiUrl = "/_api/epa_guidedtours?$select=epa_guidedtourid,epa_tourname,epa_publishingstate&$filter=statecode eq 0";
    if ($("#only-this-page-checkbox").prop("checked")) {
        apiUrl += [
            ` and (epa_guidedtourstep_GuidedTourId_epa_guidedtour/any(o1:(o1/statecode eq 0 and (o1/_epa_webpageid_value eq ${webPageId}`,
            multistepFormId
                ? ` or (o1/_epa_multistepformid_value eq ${multistepFormId}`
                : null,
            formStepId ? ` and o1/_epa_formstepid_value eq ${formStepId}` : null,
            multistepFormId ? ")" : null,
            "))))"
        ]
            .filter(Boolean)
            .join("");
    }
    return safeAjax({
        type: "GET",
        url: apiUrl,
        contentType: "application/json"
    })
        .done(function (response, status, xhr) {
        const selectElement = $("#select-tour");
        selectElement.empty();
        selectElement.append("<option value=''>-- Select a Tour --</option>");
        response.value.forEach(function (item) {
            selectElement.append(`<option value="${item.epa_guidedtourid}">${item.epa_tourname} (${item["epa_publishingstate@OData.Community.Display.V1.FormattedValue"]})</option>`);
        });
    })
        .fail(function (xhr, status, error) {
        console.error("Error loading tours: ", error);
    });
}
function showSelectTourContainer() {
    currentTour = null;
    currentSteps = [];
    currentStep = null;
    populateTourSelect().done(function () {
        $("#change-tour-button").hide();
        $("#tour-details-button").hide();
        $("#test-tour-button").hide();
        $("#tour-details-container").hide();
        $("#step-container").hide();
        $("#step-details-container").hide();
        $("#create-tour-button").show();
        $("#select-tour-container").show();
    });
}
function setTourDetails() {
    if (!currentTour) {
        return;
    }
    $("#epa_tourname-input").val(currentTour.epa_tourname || "");
    $(`input[name="epa_publishingstate-radio"][value="${currentTour.epa_publishingstate ||
        false}"]`).prop("checked", "checked");
    $(`input[name="epa_showprogressbar-radio"][value="${currentTour.epa_showprogressbar ||
        true}"]`).prop("checked", "checked");
    $("#epa_touroptions-textarea").val(currentTour.epa_touroptions || "");
    $("#epa_onstartscript-textarea").val(currentTour.epa_onstartscript || "");
    $("#epa_setupscript-textarea").val(currentTour.epa_setupscript || "");
    $(`input[name="epa_relaunchalways-radio"][value="${currentTour.epa_relaunchalways ||
        false}"]`).prop("checked", "checked");
    if (currentTour.epa_relaunchalways) {
        $("#relaunch-settings-container").collapse("hide");
    }
    else {
        $("#relaunch-settings-container").collapse("show");
        setDateTimeInput(document.getElementById("epa_relaunchafterdate-input"), currentTour.epa_relaunchafterdate);
        $("#epa_inactivitydurationbeforerelaunch-input").val(currentTour.epa_inactivitydurationbeforerelaunch || "");
    }
}
function showTourDetailsContainer() {
    $("#create-tour-button").hide();
    $("#tour-details-button").hide();
    $("#test-tour-button").hide();
    $("#select-tour-container").hide();
    $("#step-container").hide();
    $("#step-details-container").hide();
    setTourDetails();
    $("#change-tour-button").show();
    $("#tour-details-container").show();
}
function getTourById(tourId) {
    if (!tourId) {
        throw new Error("Tour ID is required");
    }
    return safeAjax({
        type: "GET",
        url: `/_api/epa_guidedtours(${tourId})`,
        contentType: "application/json"
    });
}
function getTourStepsByTourId(tourId) {
    if (!tourId) {
        throw new Error("Tour ID is required");
    }
    return safeAjax({
        type: "GET",
        url: `/_api/epa_guidedtoursteps?$filter=_epa_guidedtourid_value eq ${tourId}&$orderby=epa_order`,
        contentType: "application/json"
    });
}
function addHighlightRow(value) {
    const container = $(`<div class="input-group"></div>`);
    const input = $(`<input type="text" class="form-control" ${value ? `value="${value}"` : ""} />`);
    const search = $(`<span class="select-element-button input-group-addon"><span class="fa fa-search"></span></span>`);
    const button = $(`<span class="delete-highlight-button input-group-addon"><span class="fa fa-trash"></span></span>`);
    button.on("click", function () {
        container.remove();
    });
    container.append(input);
    container.append(search);
    container.append(button);
    $("#highlight-container").append(container);
}
function setStepDetails() {
    if (!currentStep) {
        return;
    }
    $("#epa_steptitle-input").val(currentStep.epa_steptitle || "");
    $("#epa_stepcontent-textarea").val(currentStep.epa_stepcontent || "");
    $("#epa_order-input").val(currentStep.epa_order || 1);
    $(`input[name="epa_attachtoelement-radio"][value="${currentStep.epa_attachtoelement}"]`).prop("checked", "checked");
    if (currentStep.epa_attachtoelement) {
        $("#attach-to-element-container").collapse("show");
        $("#epa_element-input").val(currentStep.epa_element || "");
        $("#epa_on-select").val(currentStep.epa_on || "");
    }
    else {
        $("#attach-to-element-container").collapse("hide");
    }
    const highlights = currentStep.epa_extrahighlights
        ? JSON.parse(currentStep.epa_extrahighlights)
        : [];
    $("#highlight-container").empty();
    if (highlights?.length) {
        highlights.forEach(highlight => {
            addHighlightRow(highlight);
        });
    }
    else {
        addHighlightRow();
    }
    $("#epa_buttontype-select").val(currentStep.epa_buttontype || "");
    if (currentStep.epa_buttontype === 423940006) {
        $("#custom-button-container").collapse("show");
        $("#epa_custombuttons-textarea").val(currentStep.epa_custombuttons || "");
    }
    else {
        $("#custom-button-container").collapse("hide");
    }
    $("#epa_additionaloptions-textarea").val(currentStep.epa_additionaloptions || "");
}
function updateStepOrder(updatedItem) {
    if (updatedItem) {
        const index = currentSteps.findIndex(x => x.epa_guidedtourstepid === updatedItem.epa_guidedtourstepid);
        if (index === -1)
            return;
        const itemOrder = (currentStep?.epa_order || 0) < (updatedItem?.epa_order || 0) ? 1 : -1;
        currentSteps[index] = updatedItem;
        currentSteps.sort((a, b) => a.epa_order === b.epa_order &&
            (a.epa_guidedtourstepid === updatedItem.epa_guidedtourstepid ||
                b.epa_guidedtourstepid === updatedItem.epa_guidedtourstepid)
            ? a.epa_guidedtourstepid === updatedItem.epa_guidedtourstepid
                ? itemOrder
                : itemOrder * -1
            : (a.epa_order || 0) - (b.epa_order || 0));
    }
    else {
        currentSteps.sort((a, b) => (a.epa_order || 0) - (b.epa_order || 0));
    }
    for (let i = 0; i < currentSteps.length; i++) {
        if (currentSteps[i].epa_order !== i + 1) {
            currentSteps[i].epa_order = i + 1;
            safeAjax({
                method: "PATCH",
                url: `/_api/epa_guidedtoursteps(${currentSteps[i].epa_guidedtourstepid})`,
                contentType: "application/json",
                data: JSON.stringify({ epa_order: i + 1 })
            }).fail(function (xhr, status, error) {
                console.error("Error updating record: ", error);
            });
        }
    }
}
function createNewStep(order) {
    return {
        epa_guidedtourstepid: null,
        _epa_guidedtourid_value: currentTour?.epa_guidedtourid || null,
        _epa_webpageid_value: webPageId,
        _epa_multistepformid_value: multistepFormId,
        _epa_formstepid_value: formStepId,
        epa_steptitle: null,
        epa_stepcontent: null,
        epa_order: order,
        epa_attachtoelement: false,
        epa_element: null,
        epa_on: null,
        epa_extrahighlights: null,
        epa_buttontype: null,
        epa_custombuttons: null,
        epa_additionaloptions: null
    };
}
function showStepDetailsContainer() {
    $("#create-tour-button").hide();
    $("#tour-details-button").hide();
    $("#test-tour-button").hide();
    $("#change-tour-button").hide();
    $("#select-tour-container").hide();
    $("#tour-details-container").hide();
    $("#step-container").hide();
    setStepDetails();
    $("#step-details-container").show();
}
function populateTourSteps() {
    const stepContainer = $("#step-container");
    stepContainer.empty();
    if (!currentSteps.length) {
        const addButton = $('<button class="shepherd-button">Add</button>');
        addButton.on("click", function () {
            currentStep = createNewStep(1);
            showStepDetailsContainer();
        });
        stepContainer.append(addButton);
        return;
    }
    currentSteps.forEach(function (step, index) {
        const stepElement = $(`<div data-step-id="${step.epa_guidedtourstepid}" class="list-group-item">
        <button class="shepherd-button add-before-button">Add Before</button>
        <h4 class="list-group-item-heading">${step.epa_steptitle}</h4>
        <div class="list-group-item-text">
          ${step.epa_stepcontent}
        </div>
        <div class="step-button-container">
          <div>
            <button class="shepherd-button edit-button">Edit</button>
            <button class="shepherd-button delete-button">Delete</button>
          </div>
          <button class="shepherd-button add-after-button">Add After</button>
        </div>
      </div>`);
        stepElement.find("button.edit-button").on("click", function () {
            currentStep = step;
            showStepDetailsContainer();
        });
        stepElement.find("button.add-before-button").on("click", function () {
            currentStep = createNewStep(index + 1);
            showStepDetailsContainer();
        });
        stepElement.find("button.add-after-button").on("click", function () {
            currentStep = createNewStep(index + 2);
            showStepDetailsContainer();
        });
        stepElement.find("button.delete-button").on("click", function () {
            safeAjax({
                method: "DELETE",
                url: `/_api/epa_guidedtoursteps(${step.epa_guidedtourstepid})`,
                contentType: "application/json"
            })
                .done(function (response, status, xhr) {
                const index = currentSteps.findIndex(x => x.epa_guidedtourstepid === step.epa_guidedtourstepid);
                if (index !== -1) {
                    currentSteps.splice(index, 1);
                    updateStepOrder(null);
                    populateTourSteps();
                }
            })
                .fail(function (xhr, status, error) {
                console.error("Error deleting record: ", error);
            });
        });
        stepContainer.append(stepElement);
    });
}
function showTourStepsContainer() {
    populateTourSteps();
    $("#create-tour-button").hide();
    if (currentSteps.length) {
        $("#test-tour-button").show();
    }
    $("#tour-details-button").show();
    $("#change-tour-button").show();
    $("#select-tour-container").hide();
    $("#step-container").show();
    $("#step-details-container").hide();
    $("#tour-details-container").hide();
}
function createTestTour() {
    return new Shepherd.Tour({
        id: "test-tour-id",
        useModalOverlay: true,
        defaultStepOptions: {
            cancelIcon: {
                enabled: true
            },
            scrollTo: { behavior: "smooth", block: "center" }
        },
        steps: [{ title: "Test Title", text: "Test Content" }]
    });
}
function validateTourOptions() {
    const tourOptionsText = $("#epa_touroptions-textarea").val();
    if (!tourOptionsText) {
        return true;
    }
    try {
        const tourOptions = window.eval(`(${tourOptionsText})`);
        if (typeof tourOptions !== "object") {
            alert("Tour options must be an object.");
            return false;
        }
    }
    catch (e) {
        console.error("Syntax error in tour options:", e);
        alert("Invalid tour options syntax.");
        return false;
    }
    return true;
}
function validateOnStartScript() {
    const onStartScriptText = $("#epa_onstartscript-textarea").val();
    if (!onStartScriptText) {
        return true;
    }
    try {
        new Function(onStartScriptText)();
    }
    catch (e) {
        console.error("Syntax error in on start script:", e);
        alert("Invalid on start script syntax.");
        return false;
    }
    return true;
}
function validateSetupScript() {
    const setupScriptText = $("#epa_setupscript-textarea").val();
    if (!setupScriptText) {
        return true;
    }
    try {
        new Function("tour", setupScriptText)(createTestTour());
    }
    catch (e) {
        console.error("Syntax error in setup script:", e);
        alert("Invalid setup script syntax.");
        return false;
    }
    return true;
}
function validateTour() {
    if (!$("#epa_tourname-input").val()) {
        alert("Please enter a tour name.");
        return false;
    }
    if (!validateTourOptions()) {
        return false;
    }
    if (!validateOnStartScript()) {
        return false;
    }
    if (!validateSetupScript()) {
        return false;
    }
    return true;
}
function validateAdditionalOptions() {
    const additionalOptionsText = $("#epa_additionaloptions-textarea").val();
    if (!additionalOptionsText) {
        return true;
    }
    try {
        const additionalOptions = window.eval(`(${additionalOptionsText})`);
        if (typeof additionalOptions !== "object") {
            alert("Additional Options must be an object.");
            return false;
        }
    }
    catch (e) {
        console.error("Syntax error in additional options:", e);
        alert("Invalid additional options syntax.");
        return false;
    }
    return true;
}
function validateTourStep() {
    if (!$("#epa_steptitle-input").val()) {
        alert("Please enter a step title.");
        return false;
    }
    if (!$("#epa_stepcontent-textarea").val()) {
        alert("Please enter step content.");
        return false;
    }
    if (!$("#epa_order-input").val()) {
        alert("Please enter a step order.");
        return false;
    }
    if ($("#epa_attachtoelement-yes-radio").prop("checked")) {
        if (!$("#epa_element-input").val()) {
            alert("Please specify an element to attach the step to.");
            return false;
        }
        if (!$("#epa_on-select").val()) {
            alert("Please select a position for the step.");
            return false;
        }
    }
    if (!$("#epa_buttontype-select").val()) {
        alert("Please select a button type for the step.");
        return false;
    }
    if (!validateAdditionalOptions()) {
        return false;
    }
    return true;
}
function attachHandlers() {
    $("#manage-tours-button").on("click", function () {
        showSelectTourContainer();
        $("#manage-tours-sidebar").show();
        $("#manage-tours-button").hide();
    });
    $("#close-manage-tours-button").on("click", function () {
        $("#manage-tours-sidebar").removeClass("minimised");
        $("#manage-tours-sidebar").hide();
        $("#select-tour-container").hide();
        $("#create-tour-button").hide();
        $("#change-tour-button").hide();
        $("#tour-details-container").hide();
        $("#step-container").hide();
        $("#step-details-container").hide();
        currentTour = null;
        currentSteps = [];
        currentStep = null;
        $("#manage-tours-button").show();
    });
    $("#minimise-manage-tours-button").on("click", function () {
        $("#manage-tours-sidebar").toggleClass("minimised");
        $("#manage-tours-sidebar").hasClass("minimised")
            ? $(this).text("🗖")
            : $(this).text("_");
    });
    $("#only-this-page-checkbox").on("change", function () {
        populateTourSelect();
    });
    $("#create-tour-button").on("click", function () {
        currentTour = {
            epa_guidedtourid: null,
            epa_tourname: null,
            epa_publishingstate: false,
            epa_showprogressbar: true,
            epa_touroptions: null,
            epa_onstartscript: null,
            epa_setupscript: null,
            epa_relaunchalways: false,
            epa_relaunchafterdate: null,
            epa_inactivitydurationbeforerelaunch: null
        };
        showTourDetailsContainer();
    });
    $("#select-tour").on("change", function () {
        const tourId = $(this).val();
        if (!tourId) {
            return;
        }
        getTourById(tourId).done(function (response, status, xhr) {
            if (!response) {
                console.error("Could not retrieve tour.");
                return;
            }
            currentTour = response;
            showTourDetailsContainer();
        });
    });
    $("#change-tour-button").on("click", function () {
        showSelectTourContainer();
    });
    $("#tour-details-button").on("click", function () {
        showTourDetailsContainer();
    });
    $("#test-tour-button").on("click", function () {
        if (!currentTour) {
            alert("Please select or create a tour before testing.");
            return;
        }
        if (!currentTour.epa_tourname) {
            alert("Please enter a tour name before testing.");
            return;
        }
        let tourOptions = {};
        if (currentTour.epa_touroptions) {
            try {
                tourOptions = window.eval(`(${currentTour.epa_touroptions})`);
            }
            catch (e) {
                console.error("Syntax error in tour options:", e);
                alert("Invalid tour options syntax. Please correct it before testing.");
                return;
            }
        }
        let onStartScript = null;
        if (currentTour.epa_onstartscript) {
            try {
                onStartScript = new Function(currentTour.epa_onstartscript);
            }
            catch (e) {
                console.error("Syntax error in onStart script:", e);
                alert("Invalid onStart script syntax. Please correct it before testing.");
                return;
            }
        }
        let setupScript = null;
        if (currentTour.epa_setupscript) {
            try {
                setupScript = new Function("tour", currentTour.epa_setupscript);
            }
            catch (e) {
                console.error("Syntax error in setup script:", e);
                alert("Invalid setup script syntax. Please correct it before testing.");
                return;
            }
        }
        const steps = currentSteps
            .map(currentStep => {
            if (!currentStep.epa_steptitle || !currentStep.epa_stepcontent) {
                alert("All steps must have a title and content before testing the tour.");
                return null;
            }
            let step = {
                title: currentStep.epa_steptitle,
                text: currentStep.epa_stepcontent
            };
            if (currentStep.epa_attachtoelement) {
                if (!currentStep.epa_element) {
                    alert("All steps that are attached to an element must have an element specified before testing the tour.");
                    return null;
                }
                let element = null;
                try {
                    element = window.eval(currentStep.epa_element);
                }
                catch (e) {
                    console.error("Syntax error in step element:", e);
                    alert("Invalid step element syntax. Please correct it before testing.");
                    return null;
                }
                const onValues = {
                    423940000: "top",
                    423940001: "bottom",
                    423940002: "left",
                    423940003: "right"
                };
                if (!currentStep.epa_on) {
                    alert("All steps that are attached to an element must have an 'on' position specified before testing the tour.");
                    return null;
                }
                const currentStepOnValue = onValues[currentStep.epa_on];
                if (!currentStepOnValue) {
                    alert("Invalid 'on' position specified for the step. Please select a valid position.");
                    return null;
                }
                step.attachTo = {
                    element: element,
                    on: currentStepOnValue
                };
            }
            if (currentStep.epa_extrahighlights) {
                const highlights = JSON.parse(currentStep.epa_extrahighlights);
                if (!Array.isArray(highlights)) {
                    alert("Invalid extra highlights format. Expected an array of strings.");
                    return null;
                }
                step.extraHighlights = highlights;
            }
            switch (currentStep.epa_buttontype) {
                case 423940000:
                    step.buttons = [];
                    break;
                case 423940001:
                    step.buttons = [
                        {
                            text: "Get Started",
                            action() {
                                return this.next();
                            }
                        }
                    ];
                    break;
                case 423940002:
                    step.buttons = [
                        {
                            text: "Back",
                            action() {
                                return this.back();
                            }
                        }
                    ];
                    break;
                case 423940003:
                    step.buttons = [
                        {
                            text: "Next",
                            action() {
                                return this.next();
                            }
                        }
                    ];
                    break;
                case 423940004:
                    step.buttons = [
                        {
                            text: "Back",
                            action() {
                                return this.back();
                            }
                        },
                        {
                            text: "Next",
                            action() {
                                return this.next();
                            }
                        }
                    ];
                    break;
                case 423940005:
                    step.buttons = [
                        {
                            text: "Back",
                            action() {
                                return this.back();
                            }
                        },
                        {
                            text: "Finish Tour",
                            action() {
                                return this.complete();
                            }
                        }
                    ];
                    break;
                case 423940006:
                    const customButtonsText = $("#epa_custombuttons-textarea").val();
                    const buttons = window.eval(customButtonsText);
                    if (!buttons ||
                        !Array.isArray(buttons) ||
                        !buttons.every((button) => button && typeof button === "object")) {
                        alert("Invalid custom buttons format. Expected an array of button objects.");
                        return null;
                    }
                    step.buttons = buttons;
                    break;
                default:
                    alert("Invalid button type.");
                    return null;
            }
            if (currentTour?.epa_showprogressbar) {
                step.when = {
                    show() {
                        const currentStep = this.tour?.getCurrentStep();
                        if (!currentStep) {
                            return;
                        }
                        const currentStepNumber = this.tour?.steps.indexOf(currentStep) + 1;
                        const totalStepCount = this.tour?.steps.length;
                        const percentComplete = (currentStepNumber / totalStepCount) * 100;
                        const progress = document.createElement("div");
                        progress.className = "shepherd-progress";
                        const progressText = document.createElement("div");
                        progressText.className = "shepherd-progress-text";
                        progressText.innerText = `Step ${currentStepNumber} of ${totalStepCount}`;
                        progress?.append(progressText);
                        const progressBar = document.createElement("div");
                        progressBar.className = "shepherd-progress-bar";
                        progress?.append(progressBar);
                        const progressBarFill = document.createElement("div");
                        progressBarFill.className = "shepherd-progress-fill";
                        progressBarFill.style.width = `${percentComplete}%`;
                        progressBar.append(progressBarFill);
                        const currentStepElement = currentStep?.getElement();
                        const textElement = currentStepElement?.querySelector(".shepherd-text");
                        textElement?.prepend(progress);
                    }
                };
            }
            if (!currentStep.epa_additionaloptions) {
                return step;
            }
            try {
                const additionalOptions = window.eval(`(${currentStep.epa_additionaloptions})`);
                if (!additionalOptions || typeof additionalOptions !== "object") {
                    alert("Invalid additional options format. Expected an object.");
                    return null;
                }
                step = {
                    ...step,
                    ...additionalOptions
                };
                return step;
            }
            catch (e) {
                console.error("Syntax error in additional options:", e);
                alert("Invalid additional options syntax. Please correct it.");
                return null;
            }
        })
            .filter(Boolean);
        if (!steps.length) {
            return;
        }
        const tour = new Shepherd.Tour({
            id: "test-tour-id",
            tourName: currentTour.epa_tourname,
            useModalOverlay: true,
            defaultStepOptions: {
                cancelIcon: {
                    enabled: true
                },
                scrollTo: { behavior: "smooth", block: "center" }
            },
            steps: steps,
            ...tourOptions
        });
        if (setupScript) {
            setupScript(tour);
        }
        if (onStartScript) {
            tour.on("start", function () {
                onStartScript();
            });
        }
        tour.on("inactive", function () {
            $("#manage-tours-sidebar").show();
        });
        $("#manage-tours-sidebar").hide();
        tour.start();
    });
    $("#epa_touroptions-validate-button").on("click", function () {
        $("#epa_touroptions-isvalid").text(validateTourOptions());
    });
    $("#epa_onstartscript-validate-button").on("click", function () {
        $("#epa_onstartscript-isvalid").text(validateOnStartScript());
    });
    $("#epa_setupscript-validate-button").on("click", function () {
        $("#epa_setupscript-isvalid").text(validateSetupScript());
    });
    $("#relaunch-settings-container").on("hide.bs.collapse", function () {
        $("#epa_relaunchafterdate-input").val("");
        $("#epa_inactivitydurationbeforerelaunch-input").val("");
    });
    $("input[name='epa_relaunchalways-radio']").on("change", function () {
        if (this.value.toLowerCase() === "true") {
            $("#relaunch-settings-container").collapse("hide");
        }
        else {
            $("#relaunch-settings-container").collapse("show");
        }
    });
    $("#reset-button").on("click", function () {
        setTourDetails();
    });
    $("#cancel-button").on("click", function () {
        showSelectTourContainer();
    });
    $("#save-button").on("click", function () {
        if (!currentTour) {
            throw new Error("Current Tour must be populated.");
        }
        if (!validateTour()) {
            return;
        }
        const tourUpdates = getUpdatedProperties(currentTour, {
            epa_tourname: $("#epa_tourname-input").val() || null,
            epa_publishingstate: String($("input[name='epa_publishingstate-radio']:checked").val()).toLowerCase() === "true",
            epa_showprogressbar: String($("input[name='epa_showprogressbar-radio']:checked").val()).toLowerCase() === "true",
            epa_touroptions: $("#epa_touroptions-textarea").val() || null,
            epa_onstartscript: $("#epa_onstartscript-textarea").val() || null,
            epa_setupscript: $("#epa_setupscript-textarea").val() || null,
            epa_relaunchalways: String($("input[name='epa_relaunchalways-radio']:checked").val()).toLowerCase() === "true",
            epa_relaunchafterdate: $("#epa_relaunchafterdate-input").val()
                ? new Date(String($("#epa_relaunchafterdate-input").val()))
                    .toISOString()
                    .split(".")[0] + "Z"
                : null,
            epa_inactivitydurationbeforerelaunch: $("#epa_inactivitydurationbeforerelaunch-input").val()
                ? Number($("#epa_inactivitydurationbeforerelaunch-input").val())
                : null
        });
        if (currentTour.epa_guidedtourid) {
            const loadTourSteps = function () {
                getTourStepsByTourId(currentTour.epa_guidedtourid).done(function (response, status, xhr) {
                    if (!response) {
                        console.error("Could not retrieve tour steps.");
                        return;
                    }
                    currentSteps = response.value;
                    showTourStepsContainer();
                });
            };
            if (!Object.keys(tourUpdates).length) {
                loadTourSteps();
                return;
            }
            safeAjax({
                method: "PATCH",
                url: `/_api/epa_guidedtours(${currentTour.epa_guidedtourid})`,
                contentType: "application/json",
                data: JSON.stringify(tourUpdates)
            })
                .done(function (response, status, xhr) {
                currentTour = {
                    ...currentTour,
                    ...tourUpdates
                };
                loadTourSteps();
            })
                .fail(function (xhr, status, error) {
                console.error("Error updating record: ", error);
            });
        }
        else {
            if (!Object.keys(tourUpdates).length) {
                return;
            }
            safeAjax({
                method: "POST",
                url: "/_api/epa_guidedtours",
                contentType: "application/json",
                data: JSON.stringify(tourUpdates)
            })
                .done(function (response, status, xhr) {
                currentTour = {
                    ...currentTour,
                    ...tourUpdates,
                    epa_guidedtourid: xhr.getResponseHeader("entityid")
                };
                currentSteps = [];
                currentStep = createNewStep(1);
                showStepDetailsContainer();
            })
                .fail(function (xhr, status, error) {
                console.error("Error creating record: ", error);
            });
        }
    });
    $("#attach-to-element-container").on("hide.bs.collapse", function () {
        $("#epa_element-input").val("");
        $("#epa_on-select").val("");
    });
    $("input[name='epa_attachtoelement-radio']").on("change", function () {
        if (this.value.toLowerCase() === "true") {
            $("#attach-to-element-container").collapse("show");
        }
        else {
            $("#attach-to-element-container").collapse("hide");
        }
    });
    $("#add-highlight-button").on("click", function () {
        addHighlightRow();
    });
    $("#custom-button-container").on("hide.bs.collapse", function () {
        $("#epa_custombuttons-textarea").val("");
    });
    $("#epa_buttontype-select").on("change", function () {
        if (Number(this.value) === 423940006) {
            $("#custom-button-container").collapse("show");
        }
        else {
            $("#custom-button-container").collapse("hide");
        }
    });
    $("#epa_custombuttons-validate-button").on("click", function () {
        const customButtonsText = $("#epa_custombuttons-textarea").val();
        if (!customButtonsText) {
            $("#epa_custombuttons-isvalid").text(true);
            return;
        }
        let isValid = false;
        try {
            const buttons = window.eval(customButtonsText);
            isValid =
                Array.isArray(buttons) &&
                    buttons.every((button) => button && typeof button === "object");
        }
        catch (e) {
            console.error("Syntax error:", e);
            isValid = false;
        }
        $("#epa_custombuttons-isvalid").text(isValid);
    });
    $("#epa_additionaloptions-validate-button").on("click", function () {
        $("#epa_additionaloptions-isvalid").text(validateAdditionalOptions());
    });
    $("#reset-step-button").on("click", function () {
        setStepDetails();
    });
    $("#cancel-step-button").on("click", function () {
        showTourStepsContainer();
    });
    $("#save-step-button").on("click", function () {
        if (!currentTour) {
            throw new Error("Current Tour must be populated.");
        }
        if (!currentStep) {
            throw new Error("Current Step must be populated.");
        }
        if (!validateTourStep()) {
            return;
        }
        const highlights = $("#highlight-container")
            .find("input")
            .map((_, element) => element.value)
            .get()
            .filter(Boolean);
        const stepUpdates = getUpdatedProperties(currentStep, {
            epa_steptitle: $("#epa_steptitle-input").val() || null,
            epa_stepcontent: $("#epa_stepcontent-textarea").val() || null,
            epa_order: $("#epa_order-input").val()
                ? Number($("#epa_order-input").val())
                : null,
            epa_attachtoelement: String($("input[name='epa_attachtoelement-radio']:checked").val()).toLowerCase() === "true",
            epa_element: $("#epa_element-input").val() || null,
            epa_on: $("#epa_on-select").val()
                ? Number($("#epa_on-select").val())
                : null,
            epa_extrahighlights: highlights.length
                ? JSON.stringify(highlights)
                : null,
            epa_buttontype: $("#epa_buttontype-select").val()
                ? Number($("#epa_buttontype-select").val())
                : null,
            epa_custombuttons: $("#epa_custombuttons-textarea").val() || null,
            epa_additionaloptions: $("#epa_additionaloptions-textarea").val() || null
        });
        if (currentStep.epa_guidedtourstepid) {
            if (!Object.keys(stepUpdates).length) {
                return showTourStepsContainer();
            }
            safeAjax({
                method: "PATCH",
                url: `/_api/epa_guidedtoursteps(${currentStep.epa_guidedtourstepid})`,
                contentType: "application/json",
                data: JSON.stringify(stepUpdates)
            })
                .done(function (response, status, xhr) {
                updateStepOrder({ ...currentStep, ...stepUpdates });
                currentStep = null;
                showTourStepsContainer();
            })
                .fail(function (xhr, status, error) {
                console.error("Error updating record: ", error);
            });
        }
        else {
            if (!Object.keys(stepUpdates).length) {
                return;
            }
            const newStep = {
                ...stepUpdates,
                "epa_GuidedTourId@odata.bind": `/epa_guidedtours(${currentTour.epa_guidedtourid})`,
                epa_order: stepUpdates.epa_order || currentStep.epa_order
            };
            if (multistepFormId) {
                newStep["epa_MultistepFormId@odata.bind"] = `/adx_webforms(${multistepFormId})`;
                if (formStepId) {
                    newStep["epa_FormStepId@odata.bind"] = `/adx_webformsteps(${formStepId})`;
                }
            }
            else {
                newStep["epa_WebPageId@odata.bind"] = `/adx_webpages(${webPageId})`;
            }
            safeAjax({
                method: "POST",
                url: "/_api/epa_guidedtoursteps",
                contentType: "application/json",
                data: JSON.stringify(newStep)
            })
                .done(function (response, status, xhr) {
                const updatedItem = {
                    ...currentStep,
                    ...stepUpdates,
                    epa_guidedtourstepid: xhr.getResponseHeader("entityid")
                };
                currentSteps.push(updatedItem);
                updateStepOrder(updatedItem);
                currentStep = null;
                showTourStepsContainer();
            })
                .fail(function (xhr, status, error) {
                console.error("Error creating record: ", error);
            });
        }
    });
    $(document).on("click", ".select-element-button", function (event) {
        event.stopPropagation();
        setSelectElementTarget($(this).siblings("input"));
        $(document).on("mouseover", selectElement);
        document.addEventListener("click", removeSelectElementHandlers, {
            capture: true,
            once: true
        });
        $("#manage-tours-sidebar").hide();
    });
}
function initializeTourManagement(buttonContainerId, pageId, formId, stepId) {
    webPageId = pageId;
    multistepFormId = formId;
    formStepId = stepId;
    const tourButtonsContainer = document.getElementById(buttonContainerId);
    if (tourButtonsContainer) {
        const button = document.createElement("button");
        button.id = "manage-tours-button";
        button.className = "btn btn-primary";
        button.textContent = "Manage Tours";
        tourButtonsContainer.append(button);
    }
    attachHandlers();
}
Object.assign(window, {
    initializeTourManagement
});
